import React from 'react';

/**
 * Horizontal progress line for file uploads.
 * @param {number|null} progress 0–100, or null to hide
 * @param {boolean} indeterminate show animated bar when total size is unknown
 */
export function UploadProgressBar({
  progress,
  label = 'Uploading…',
  indeterminate = false,
  className = '',
}) {
  if (progress == null && !indeterminate) {
    return null;
  }

  const showPercent = typeof progress === 'number' && !indeterminate;

  return (
    <div className={`mt-2 ${className}`} role="status" aria-live="polite">
      <div className="flex justify-between text-xs text-slate-600 mb-1 gap-2">
        <span className="truncate">{label}</span>
        {showPercent ? <span className="tabular-nums shrink-0">{progress}%</span> : null}
      </div>
      <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden">
        {indeterminate ? (
          <div className="h-full w-1/2 bg-primary-600 rounded-full animate-pulse" />
        ) : (
          <div
            className="h-full bg-primary-600 rounded-full transition-[width] duration-200 ease-out"
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
        )}
      </div>
    </div>
  );
}

export default UploadProgressBar;
